export default "__VITE_ASSET__CqrudDjT__";